<template>
    <div class="display-flex flex-col">
        <div class="integralItem-title">
            <a-button class="bott" @click="this.$router.back()" type="primary">返回列表</a-button>
            <a-steps style="position:fixed;margin-left:680px;width:200px;z-index:999;cursor: pointer;" direction="vertical" :current="current">
                <a-step @click="current=0" title="核心指标" description="企业核心指标." />
                <a-step @click="current=1" title="辅助指标" description="企业辅助指标." />
                <a-step @click="current=2" title="逆向指标" description="企业逆向指标." />
            </a-steps>
            <h4 class="display-flex justify-center content-center" style="width:650px;">填报{{ nowYear-1 }}年积分创新指标(种子期)<em>*</em></h4>

            <!-- <p class="display-flex justify-center content-center">企业积分采用不设上限方式，分数每季度更新一次，支持累积</p> -->
        </div>
        <div class="integralItem-cont display-flex flex-1">
            <a-form ref="ruleForm" :model="form" :rules="rules" layout="vertical">
            <a-row v-show="current==0" class="item-form" :gutter="[24,8]">

                <a-col :span="24">
                    <h4 class="left-border">核心指标</h4>
                </a-col>
                <a-col :span="24">
                    <a-form-item style="position:relative" :label="(nowYear - 1) + '年营业收入'" name="operatingIncome">
                        <span style="color:red;position:absolute;top:-30px;left:100px">（请认真核对该项数据，如需更改，请返回列表，删除该表重新填报）</span>
                        <a-input style="width:30%" disabled v-model:value="form.operatingIncome"
                            :placeholder="'请输入' + (nowYear - 1) + '年营业收入'" /> 万元
                    <FileUpload :isPdf="true" style="display: inline-block;margin-left:10px;width:0;height:0;overflow:hidden"   :names="'上传'+(nowYear-1)+'年利润表(PDF文件)'" v-model:value="form.operatingIncomeFile" :showBtn="false" disabled/>

                    <p v-if="reason[0].checked==false">错误原因：<span v-if="reason[0].reason">{{reason[0].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24">
                <a-form-item :label="(nowYear-1) + '年研发费用金额'" name="researchDevelopmentAmount">
                    <a-input-number style="width:30%"  v-model:value="form.researchDevelopmentAmount" :placeholder="'请输入'+(nowYear-1) + '年研发费用金额'"/>
                    万元
                    <p v-if="reason[1].checked==false">错误原因：<span v-if="reason[1].reason">{{reason[1].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24" class="btFILE">
                    <a-form-item name="researchDevelopmentAmountFile">
                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"   :names="(nowYear-1) + '年研发费用加计扣除费用明细表(PDF文件)'" v-model:value="form.researchDevelopmentAmountFile"/>

                    </a-form-item>
                    </a-col>
                <a-col :span="24">
                    <a-form-item :label="(nowYear-2) + '年营业收入'" name="operatingIncomePreviousYear">
                    <a-input-number style="width:30%"  v-model:value="form.operatingIncomePreviousYear" :placeholder="'请输入'+(nowYear-2) + '年营业收入'"/>
                        万元
                    <p v-if="reason[2].checked==false">错误原因：<span v-if="reason[2].reason">{{reason[2].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24" class="btFILE">
                    <a-form-item name="operatingIncomePreviousYearFile">

                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"
                            :names="(nowYear - 2) + '年营收(财务报表:资产负债表;利润表;现金流量表)(PDF文件)'" v-model:value="form.operatingIncomePreviousYearFile" />

                    </a-form-item>
                </a-col>

                <!-- <a-col :span="24" class="btFILE">
                    <a-form-item name="operatingIncomePreviousYearFile1">

                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"
                            :names="(nowYear - 2) + '年资产负债表(PDF文件)'" v-model:value="form.operatingIncomePreviousYearFile1" />

                    </a-form-item>
                </a-col>
                <a-col :span="24" class="btFILE" style="margin-top:45px">
                    <a-form-item name="operatingIncomePreviousYearFile2">

                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"
                            :names="(nowYear - 2) + '年利润表(PDF文件)'" v-model:value="form.operatingIncomePreviousYearFile2" />

                    </a-form-item>
                </a-col>
                <a-col :span="24" class="btFILE" style="margin-top:45px">
                    <a-form-item name="operatingIncomePreviousYearFile3">

                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"
                            :names="(nowYear - 2) + '年现金流量表(PDF文件)'" v-model:value="form.operatingIncomePreviousYearFile3" />

                    </a-form-item>
                </a-col> -->
                <a-col  v-if="form.operatingIncomePreviousYear<form.operatingIncome&&form.operatingIncome>0" :span="24">
                    <a-form-item label="营业收入增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.operatingIncomePreviousYear" disabled
                            :value="Math.abs((((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1))"
                            placeholder="请输入营业收入增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入营业收入增长率" />
                        %
                    </a-form-item>
                </a-col>
                <a-col  v-else-if="form.operatingIncome<0&&form.operatingIncomePreviousYear<0" :span="24">
                    <a-form-item label="营业收入增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.operatingIncomePreviousYear" disabled
                            :value="((((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1)) < 0 ? ((((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1)) : (-(((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1))"
                            placeholder="请输入营业收入增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入营业收入增长率" />
                        %
                    </a-form-item>
                </a-col>
                <a-col v-else :span="24">
                    <a-form-item label="营业收入增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.operatingIncomePreviousYear" disabled
                        :value="(((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1)"
                        placeholder="请输入营业收入增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入营业收入增长率" />
                        %
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="24">
                    <a-form-item label="营业收入增长率" name="operatingIncome">
                    <a-input  style="width:30%" v-if="form.operatingIncomePreviousYear" addon-after="%" disabled :value="(((form.operatingIncome - form.operatingIncomePreviousYear) / form.operatingIncomePreviousYear) * 100).toFixed(1)" placeholder="请输入营业收入增长率"/>
                    <a-input  style="width:30%" v-else addon-after="%" disabled :value="''" placeholder="请输入营业收入增长率"/>
                </a-form-item>
                </a-col> -->
                <a-col :span="24">
                    <a-form-item :label="(nowYear-1) + '年高新技术产品（服务）收入'" name="incomeFromhighTechProducts">
                        <a-input-number style="width:30%"   v-model:value="form.incomeFromhighTechProducts"  :placeholder="'请输入'+(nowYear-1) + '年高新技术产品（服务）收入'"/>
                        万元
                        <!-- <FileUpload :isPdf="true" style="display: inline-block;margin-left:10px"   names="纳税申报表" v-model:value="form.incomeFromhighTechProductsFile"/> -->

                        <p v-if="reason[11].checked==false">错误原因：<span v-if="reason[11].reason">{{reason[11].reason}}</span></p>
                    </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item :label="(nowYear-1) + '年净资产金额'" name="netAssetAmount">
                        <a-input-number style="width:30%"   v-model:value="form.netAssetAmount" :placeholder="'请输入'+(nowYear-1) + '年净资产金额'"/>
                        万元
                        <p v-if="reason[12].checked==false">错误原因：<span v-if="reason[12].reason">{{reason[12].reason}}</span></p>
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="24" class="btFILE">
                    <a-form-item name="netAssetAmountFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"   :names="(nowYear-1) + '年财务报表(PDF文件)'" v-model:value="form.netAssetAmountFile"/>

                </a-form-item>
                </a-col> -->

                <a-col :span="24">
                    <a-form-item :label="(nowYear-2) + '年净资产金额'" name="yearBeforeNetAssetAmount">
                        <a-input-number style="width:30%"   v-model:value="form.yearBeforeNetAssetAmount" :placeholder="'请输入'+(nowYear-2) + '年净资产金额'"/>
                        万元
                        <p v-if="reason[13].checked==false">错误原因：<span v-if="reason[13].reason">{{reason[13].reason}}</span></p>
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="24" class="btFILE">
                    <a-form-item name="yearBeforeNetAssetAmountFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;"   :names="(nowYear-2) + '年财务报表(PDF文件)'" v-model:value="form.yearBeforeNetAssetAmountFile"/>

                </a-form-item>
                </a-col> -->
                <a-col  v-if="form.yearBeforeNetAssetAmount<form.netAssetAmount&&form.netAssetAmount>0" :span="24">
                    <a-form-item label="净资产增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.yearBeforeNetAssetAmount" disabled
                                 :value="Math.abs((((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1))"
                                 placeholder="请输入净资产增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入净资产增长率" />
                        %
                    </a-form-item>
                </a-col>
                <a-col  v-else-if="form.netAssetAmount<0&&form.yearBeforeNetAssetAmount<0" :span="24">
                    <a-form-item label="净资产增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.yearBeforeNetAssetAmount" disabled
                                 :value="((((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1)) < 0 ? ((((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1)) : (-(((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1))"
                                 placeholder="请输入净资产增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入净资产增长率" />
                        %
                    </a-form-item>
                </a-col>
                <a-col v-else :span="24">
                    <a-form-item label="净资产增长率" name="operatingIncome">
                        <a-input style="width:30%" v-if="form.yearBeforeNetAssetAmount" disabled
                                 :value="(((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1)"
                                 placeholder="请输入净资产增长率" />
                        <a-input style="width:30%" v-else disabled :value="''" placeholder="请输入净资产增长率" />
                        %
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="(nowYear-1) + '年技术合同成交额'" name="technicalContractTurnover">
                        <a-input-number style="width:30%"  v-model:value="form.technicalContractTurnover" :placeholder="'请输入'+(nowYear-1) + '年技术合同成交额'"/>
                        万元


                        <p v-if="reason[8].checked==false">错误原因：<span v-if="reason[8].reason">{{reason[8].reason}}</span></p>
                    </a-form-item>
                </a-col>
                <a-col :span="24" v-if="form.technicalContractTurnover>0" class="btFILE">
                    <a-form-item name="technicalContractTurnoverFile">
                        <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;" names="合同协议及在科技部门登记的相关证明(PDF文件)" v-model:value="form.technicalContractTurnoverFile"/>

                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="截止目前研发人员" name="researchDevelopmentPersonnel">
                    <a-input-number style="width:30%"  v-model:value="form.researchDevelopmentPersonnel" placeholder="请输入研发人员"/>
                        名
                    <p v-if="reason[3].checked==false">错误原因：<span v-if="reason[3].reason">{{reason[3].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24" v-if="form.researchDevelopmentPersonnel>0" class="upIMg">
                    <a-form-item name="researchDevelopmentPersonnelFile">
                    <ImgFileUpload  :isPdfImg="true" class="requStyle" style="display: inline-block;"  :count="10"  names="个税系统截图(PDF文件/图片)" v-model:value="form.researchDevelopmentPersonnelFile"/>

                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="截止目前职工总数" name="totalNumberEmployees">
                    <a-input-number style="width:30%"   v-model:value="form.totalNumberEmployees" placeholder="请输入职工总数"/>
                        名
                    <!-- <FileUpload :isPdf="true" style="display: inline-block;margin-left:10px"   names="个税系统截图" v-model:value="form.totalNumberEmployeesFile"/> -->

                    <p v-if="reason[4].checked==false">错误原因：<span v-if="reason[4].reason">{{reason[4].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="截止目前发明专利授权量" name="inventionPatentNumber">
                    <a-input-number style="width:30%"  v-model:value="form.inventionPatentNumber" placeholder="发明专利授权量"/>
                        件


                    <p v-if="reason[5].checked==false">错误原因：<span v-if="reason[5].reason">{{reason[5].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24" v-if="form.inventionPatentNumber>0" class="btFILE">
                    <a-form-item name="inventionPatentNumberFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;" names="证书(PDF文件)" v-model:value="form.inventionPatentNumberFile"/>

                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <!-- <a-form-item label="截止目前专利合作条约（PCT）专利授权量" name="pctPatentLicensing"> -->
                    <a-form-item label="截止目前国际专利（PCT）授权量" name="pctPatentLicensing">
                    <a-input-number style="width:30%"  v-model:value="form.pctPatentLicensing" placeholder="PCT专利授权量"/>
                        件

                    <p v-if="reason[6].checked==false">错误原因：<span v-if="reason[6].reason">{{reason[6].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24" v-if="form.pctPatentLicensing>0" class="btFILE">
                    <a-form-item name="pctPatentLicensingFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;" names="证书(PDF文件)" v-model:value="form.pctPatentLicensingFile"/>

                </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="(nowYear-2)+'-'+(nowYear-1) + '年软件著作权、实用新型授权量'" name="newSoftwareLicenseNumber">
                    <a-input-number style="width:30%"  v-model:value="form.newSoftwareLicenseNumber" :placeholder="'请输入'+(nowYear-2)+'-'+(nowYear-1) + '年软件著作权、实用新型授权量'"/>
                        件


                    <p v-if="reason[7].checked==false">错误原因：<span v-if="reason[7].reason">{{reason[7].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col :span="24" v-if="form.newSoftwareLicenseNumber>0" class="btFILE">
                    <a-form-item name="newSoftwareLicenseNumberFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;" names="证书(PDF文件)" v-model:value="form.newSoftwareLicenseNumberFile"/>

                </a-form-item>
                </a-col>


                <a-col :span="24">
                    <a-form-item style="position:relative" label="是否科技型中小企业" name="scienceTechnologySmesCause">
                        <a-input v-show="form.scienceTechnologySmes=='0'" style="width:30%;position:absolute;left:15%;top:0px" v-model:value="form.scienceTechnologySmesCause" placeholder="请输入科技型中小企业编号"/>
                        <a-radio-group @change="smesChange('scienceTechnologySmesCause')" v-model:value="form.scienceTechnologySmes" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <!-- <FileUpload :isPdf="true"  v-if="form.scienceTechnologySmes=='0'" style="display: inline-block;margin-left:10px"   names="编号、证书、公示文件" v-model:value="form.scienceTechnologySmesFile"/> -->

                    <p v-if="reason[9].checked==false">错误原因：<span v-if="reason[9].reason">{{reason[9].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item style="position:relative" label="是否高新技术企业" name="highTechEnterpriseCause">
                        <a-input v-if="form.highTechEnterprise=='0'" style="width:30%;position:absolute;left:15%;top:0px" v-model:value="form.highTechEnterpriseCause" placeholder="请输入高新技术企业编号"/>
                        <a-radio-group @change="smesChange('highTechEnterpriseCause')" v-model:value="form.highTechEnterprise" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <FileUpload :isPdf="true"  v-if="form.highTechEnterprise=='0'" style="width:30%;position:absolute;left:45%;top:0px"  names="高企证书(PDF文件)" v-model:value="form.highTechEnterpriseFile"/>

                    <p v-if="reason[10].checked==false">错误原因：<span v-if="reason[10].reason">{{reason[10].reason}}</span></p>
                </a-form-item>
                </a-col>



                <!-- <a-col :span="24">
                    <a-form-item label="净资产增长率" name="operatingIncome">
                    <a-input  style="width:30%" v-if="form.yearBeforeNetAssetAmount"  disabled :value="(((form.netAssetAmount - form.yearBeforeNetAssetAmount) / form.yearBeforeNetAssetAmount) * 100).toFixed(1)" placeholder="请输入净资产增长率"/>
                    <a-input  style="width:30%" v-else disabled :value="''" placeholder="请输入净资产增长率"/>
                   %
                </a-form-item>
                </a-col> -->
                </a-row>
                <a-row v-show="current==1" class="item-form" :gutter="[24,8]">
                <a-col :span="24">
                    <h4 class="left-border">辅助指标</h4>
                </a-col>
                <a-col :span="24">
                    <a-form-item :label="(nowYear-1) + '年吸纳高校应届毕业生人数'" name="freshCollegeGraduatesNumber">
                    <a-input-number style="width:30%"   v-model:value="form.freshCollegeGraduatesNumber" :placeholder="'请输入'+(nowYear-1) + '年吸纳高校应届毕业生人数'"/>
                        人
                    <!-- <FileUpload :isPdf="true" style="display: inline-block;margin-left:10px"   names="个税系统截图" v-model:value="form.freshCollegeGraduatesNumberFile"/> -->

                    <p v-if="reason[14].checked==false">错误原因：<span v-if="reason[14].reason">{{reason[14].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="近两年是否承担建设市级及以上研发或创新平台" name="researchDevelopmentPlatform">
                    <a-radio-group v-model:value="form.researchDevelopmentPlatform" name="radioGroup">
                        <a-radio value="0">是</a-radio>
                        <a-radio value="1">否</a-radio>
                    </a-radio-group>


                    <p v-if="reason[15].checked==false">错误原因：<span v-if="reason[15].reason">{{reason[15].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col v-if="form.researchDevelopmentPlatform=='0'"  :span="24" class="btFILE">
                    <a-form-item name="researchDevelopmentPlatformFile">
                    <FileUpload :isPdf="true" style="display: inline-block;"  class="requStyle"  names="证书或公示文件等(PDF文件)"  v-model:value="form.researchDevelopmentPlatformFile"/>


                </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="近两年是否承担市级及以上科技计划项目" name="scienceTechnologyProject">
                        <a-radio-group v-model:value="form.scienceTechnologyProject" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>


                    <p v-if="reason[16].checked==false">错误原因：<span v-if="reason[16].reason">{{reason[16].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col v-if="form.scienceTechnologyProject=='0'"  :span="24" class="btFILE">
                    <a-form-item name="scienceTechnologyProjectFile">
                    <FileUpload :isPdf="true" style="display: inline-block;"  class="requStyle"  names="合同协议或公示文件等(PDF文件)"  v-model:value="form.scienceTechnologyProjectFile"/>


                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="获得省级及以上创新创业大赛" name="innovationEntrepreneurshipCompetition">
                        <a-radio-group v-model:value="form.innovationEntrepreneurshipCompetition" name="radioGroup">
                            <a-radio value="0">无</a-radio>
                            <a-radio value="1">一等奖</a-radio>
                            <a-radio value="2">二等奖</a-radio>
                            <a-radio value="3">三等奖</a-radio>
                            <a-radio value="4">入围决赛</a-radio>
                        </a-radio-group>


                    <p v-if="reason[17].checked==false">错误原因：<span v-if="reason[17].reason">{{reason[17].reason}}</span></p>
                </a-form-item>
                </a-col>
                <a-col v-if="form.innovationEntrepreneurshipCompetition>'0'"  :span="24" class="btFILE" style="margin-left:100px">
                    <a-form-item name="innovationEntrepreneurshipCompetitionFile">
                    <FileUpload :isPdf="true" style="display: inline-block;"  class="requStyle"  names="证书或公示文件等(PDF文件)"  v-model:value="form.innovationEntrepreneurshipCompetitionFile"/>


                </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="获得投资风险金额" name="riskVentureFunds">
                    <a-input-number style="width:30%"  v-model:value="form.riskVentureFunds" placeholder="获得投资风险金额"/>
                        万元

                    <p v-if="reason[18].checked==false">错误原因：<span v-if="reason[18].reason">{{reason[18].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24" v-if="form.riskVentureFunds>0" class="btFILE">
                    <a-form-item name="riskVentureFundsFile">
                    <FileUpload :isPdf="true" class="requStyle" style="display: inline-block;" names="签订风险投资合同(PDF文件)" v-model:value="form.riskVentureFundsFile"/>

                </a-form-item>
                </a-col>

                </a-row>
                <a-row v-show="current==2" class="item-form" :gutter="[24,8]">
                <a-col :span="24">
                    <h4 class="left-border">逆向指标</h4>
                </a-col>
                <a-col :span="24">
                    <a-form-item label="发生重大安全生产事故" name="majorWorkplaceSafetyAccidents">
                        <a-radio-group v-model:value="form.majorWorkplaceSafetyAccidents" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <!-- <a-input style="width:300px"   v-show="form.majorWorkplaceSafetyAccidents=='0'" v-model:value="form.majorWorkplaceSafetyAccidentsCause" placeholder="请输入发生重大安全生产事故的"/> -->

                    <!-- <FileUpload :isPdf="true"  v-if="form.majorWorkplaceSafetyAccidents=='0'" style="display: inline-block;margin-left:10px"   names="印证资料" v-model:value="form.majorWorkplaceSafetyAccidentsFile"/> -->
                    <p style="display: inline-block;" v-if="form.majorWorkplaceSafetyAccidents=='0'">系统判定企业有逆向指标，企业积分将清零。</p>

                    <p v-if="reason[19].checked==false">错误原因：<span v-if="reason[19].reason">{{reason[19].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="发生严重环保违法行为" name="seriousEnvironmentalViolations">
                        <a-radio-group v-model:value="form.seriousEnvironmentalViolations" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <!-- <a-input style="width:300px"   v-show="form.seriousEnvironmentalViolations=='0'" v-model:value="form.seriousEnvironmentalViolationsCause" placeholder="请输入发生严重环保违法行为的"/> -->

                    <!-- <FileUpload :isPdf="true"  v-if="form.seriousEnvironmentalViolations=='0'" style="display: inline-block;margin-left:10px"   names="印证资料" v-model:value="form.seriousEnvironmentalViolationsFile"/> -->
                    <p style="display: inline-block;" v-if="form.seriousEnvironmentalViolations=='0'">系统判定企业有逆向指标，企业积分将清零。</p>

                    <p v-if="reason[20].checked==false">错误原因：<span v-if="reason[20].reason">{{reason[20].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="统计造假，经统计部门查处形成形成统计违法违纪案件" name="statisticsIllegalDisciplinaryCases">
                        <a-radio-group v-model:value="form.statisticsIllegalDisciplinaryCases" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <!-- <a-input style="width:300px"   v-show="form.statisticsIllegalDisciplinaryCases=='0'" v-model:value="form.statisticsIllegalDisciplinaryCasesCause" placeholder="请输入统计造假，经统计部门查处形成形成统计违法违纪案件的"/> -->

                    <!-- <FileUpload :isPdf="true" v-if="form.statisticsIllegalDisciplinaryCases=='0'" style="display: inline-block;margin-left:10px"   names="印证资料" v-model:value="form.statisticsIllegalDisciplinaryCasesFile"/> -->
                    <p style="display: inline-block;" v-if="form.statisticsIllegalDisciplinaryCases=='0'">系统判定企业有逆向指标，企业积分将清零。</p>

                    <p v-if="reason[21].checked==false">错误原因：<span v-if="reason[21].reason">{{reason[21].reason}}</span></p>
                </a-form-item>
                </a-col>

                <a-col :span="24">
                    <a-form-item label="存在其他严重失信行为" name="grossBreachTrust">
                        <a-radio-group v-model:value="form.grossBreachTrust" name="radioGroup">
                            <a-radio value="0">是</a-radio>
                            <a-radio value="1">否</a-radio>
                        </a-radio-group>
                    <!-- <a-input style="width:300px"   v-show="form.grossBreachTrust=='0'" v-model:value="form.grossBreachTrustCause" placeholder="请输入存在其他严重失信行为的"/> -->

                    <!-- <FileUpload :isPdf="true"   v-if="form.grossBreachTrust=='0'" style="display: inline-block;margin-left:10px"   names="印证资料" v-model:value="form.grossBreachTrustFile"/> -->
                    <p style="display: inline-block;" v-if="form.grossBreachTrust=='0'">系统判定企业有逆向指标，企业积分将清零。</p>

                    <p v-if="reason[22].checked==false">错误原因：<span v-if="reason[22].reason">{{reason[22].reason}}</span></p>
                </a-form-item>
                </a-col>
                </a-row>
                <!--可编辑区域 end-->
                <a-col v-show="current==0" :span="24">
                    <div >
                        <!-- <a-button style="margin-right: 10px" @click="onClose">取消</a-button> -->
                        <a-button style="margin-right: 10px" type="primary" @click="currentReset(1,false)">
                            下一步
                        </a-button>
                        <a-button type="primary" @click="currentReset(1,true)">
                            保存
                        </a-button>
                    </div>
                </a-col>
                <!--可编辑区域 end-->
                <a-col v-show="current==1" :span="24">
                    <div >
                        <!-- <a-button style="margin-right: 10px" @click="onClose">取消</a-button> --><a-button style="margin-right: 10px" type="primary" @click="current=0">
                            上一步
                        </a-button>
                        <a-button style="margin-right: 10px" type="primary" @click="currentReset(2,false)">
                            下一步
                        </a-button>
                        <a-button type="primary" @click="currentReset(2,true)">
                            保存
                        </a-button>
                    </div>
                </a-col>
                <!--可编辑区域 end-->
                <a-col v-show="current==2" :span="24">
                    <div >
                        <!-- <a-button style="margin-right: 10px" @click="onClose">取消</a-button> --><a-button style="margin-right: 10px" type="primary" @click="current=1">
                            上一步
                        </a-button>
                        <a-button style="margin-right: 10px" type="primary" @click="onSubmit(1)">
                            保存
                        </a-button>

                        <a-popconfirm title="提交之后数据将不能修改，您确认要提交吗？" @confirm="onSubmit(0)">
                            <a-button type="primary">
                                提交
                            </a-button>
                        </a-popconfirm>
                    </div>
                </a-col>
            </a-form>
        </div>

    </div>
</template>

<script>

// import { reactive } from 'vue'
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import { enterpriseOperatingIncome } from "@/api/integral";
const form = {
        researchDevelopmentAmount: null,
        operatingIncome:null,
        operatingIncomePreviousYear: null,
        researchDevelopmentPersonnel: null,
        totalNumberEmployees: null,
        inventionPatentNumber: null,
        pctPatentLicensing: null,
        newSoftwareLicenseNumber: null,
        technicalContractTurnover: null,
        scienceTechnologySmes: null,
        highTechEnterprise: null,
        riskVentureFunds: null, //获得风险投资金额(万元)
        incomeFromhighTechProducts: null,
        netAssetAmount: null,
        yearBeforeNetAssetAmount: null,
        freshCollegeGraduatesNumber: null,
        researchDevelopmentPlatform: null,
        scienceTechnologyProject: null,
        innovationEntrepreneurshipCompetition: null,
        majorWorkplaceSafetyAccidents: null,
        seriousEnvironmentalViolations: null,
        statisticsIllegalDisciplinaryCases: null,
        grossBreachTrust: null,

        researchDevelopmentAmountFile: null,
        operatingIncomeFile: null,
        operatingIncomePreviousYearFile: null,
        // operatingIncomePreviousYearFile1: null,
        // operatingIncomePreviousYearFile2: null,
        // operatingIncomePreviousYearFile3: null,
        researchDevelopmentPersonnelFile: null,
        totalNumberEmployeesFile: null,
        inventionPatentNumberFile: null,
        pctPatentLicensingFile: null,
        newSoftwareLicenseNumberFile: null,
        technicalContractTurnoverFile: null,
        scienceTechnologySmesFile: null,
        scienceTechnologySmesCause: null,
        highTechEnterpriseFile: null,
        highTechEnterpriseCause: null,
        riskVentureFundsFile: null, //获得风险投资金额(万元)
        incomeFromhighTechProductsFile: null,
        netAssetAmountFile: null,
        yearBeforeNetAssetAmountFile: null,
        freshCollegeGraduatesNumberFile: null,
        researchDevelopmentPlatformFile: null,
        scienceTechnologyProjectFile: null,
        innovationEntrepreneurshipCompetitionFile: null,
        majorWorkplaceSafetyAccidentsFile: null,
        majorWorkplaceSafetyAccidentsCause: null,
        seriousEnvironmentalViolationsFile: null,
        seriousEnvironmentalViolationsCause: null,
        statisticsIllegalDisciplinaryCasesFile: null,
        statisticsIllegalDisciplinaryCasesCause: null,
        grossBreachTrustFile: null,
        grossBreachTrustCause: null,
            }
const rules={
                researchDevelopmentAmount: [dataCheck.required({type:"number"}),dataCheck.amount],
                operatingIncome: [],
                operatingIncomePreviousYear: [dataCheck.required({type:"number"}),dataCheck.amount],
                researchDevelopmentPersonnel: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                totalNumberEmployees: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                inventionPatentNumber: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                pctPatentLicensing: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                newSoftwareLicenseNumber: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                technicalContractTurnover: [dataCheck.required({type:"number"}),dataCheck.amount],
                scienceTechnologySmes: [],
                highTechEnterprise: [],
                riskVentureFunds: [dataCheck.required({type:"number"}),dataCheck.amount],
                incomeFromhighTechProducts: [dataCheck.required({type:"number"}),dataCheck.amount],
                netAssetAmount: [dataCheck.required({type:'number'})],
                yearBeforeNetAssetAmount: [dataCheck.required({type:'number'})],
                freshCollegeGraduatesNumber: [dataCheck.required({type:"number"}), dataCheck.IntNumber],
                researchDevelopmentPlatform: [],
                scienceTechnologyProject: [],
                innovationEntrepreneurshipCompetition: [],
                majorWorkplaceSafetyAccidents: [],
                seriousEnvironmentalViolations: [],
                statisticsIllegalDisciplinaryCases: [],
                grossBreachTrust: [],

                researchDevelopmentAmountFile: [dataCheck.required({})],
                operatingIncomeFile:[],
                operatingIncomePreviousYearFile: [dataCheck.required({})],
                // operatingIncomePreviousYearFile1: [dataCheck.required({})],
                // operatingIncomePreviousYearFile2: [dataCheck.required({})],
                // operatingIncomePreviousYearFile3: [dataCheck.required({})],
                researchDevelopmentPersonnelFile: [dataCheck.required({})],
                totalNumberEmployeesFile: [],
                inventionPatentNumberFile: [dataCheck.required({})],
                pctPatentLicensingFile: [dataCheck.required({})],
                newSoftwareLicenseNumberFile: [dataCheck.required({})],
                technicalContractTurnoverFile: [dataCheck.required({})],
                scienceTechnologySmesFile: [],
                scienceTechnologySmesCause: [dataCheck.required({})],
                highTechEnterpriseFile: [],
                highTechEnterpriseCause: [dataCheck.required({}),dataCheck.highCorpCode],
                riskVentureFundsFile: [dataCheck.required({})],
                incomeFromhighTechProductsFile: [],
                netAssetAmountFile: [dataCheck.required({})],
                yearBeforeNetAssetAmountFile: [dataCheck.required({})],
                freshCollegeGraduatesNumberFile: [],
                researchDevelopmentPlatformFile: [dataCheck.required({})],
                scienceTechnologyProjectFile: [dataCheck.required({})],
                innovationEntrepreneurshipCompetitionFile: [dataCheck.required({})],
                majorWorkplaceSafetyAccidentsFile: [],
                seriousEnvironmentalViolationsFile: [],
                statisticsIllegalDisciplinaryCasesFile: [],
                grossBreachTrustFile: [],
            }
const reason = [

]
for (var reasonIndex = 0; reasonIndex <= 30; reasonIndex++) {
    reason.push(
        {
            reason: null,
            checked: true,
        },
    )
}
export default {
    name:"种子期",
    mixins: [formMixin],
    props: ["formData","reasondata"],
    components:{},
    data(){
        return{
            nowYear:new Date().getFullYear(),
            current:0,
            reason,
            form,
            rules
        }
    },
    watch: {
        'form.researchDevelopmentPersonnel'(val){
            if(val == 0){
                this.form.researchDevelopmentPersonnelFile = null
            }
        },
        'form.inventionPatentNumber'(val) {
            if(val == 0){
                this.form.inventionPatentNumberFile = null
            }
        },
        'form.pctPatentLicensing'(val) {
            if(val == 0){
                this.form.pctPatentLicensingFile = null
            }
        },
        'form.newSoftwareLicenseNumber'(val) {
            if(val == 0){
                this.form.newSoftwareLicenseNumberFile = null
            }
        },
        'form.technicalContractTurnover'(val) {
            if(val == 0){
                this.form.technicalContractTurnoverFile = null
            }
        },
        'form.highTechEnterprise'(val) {
            if(val == 1){
                this.form.highTechEnterpriseFile = null
            }
        },
        'form.researchDevelopmentPlatform'(val) {
            if(val == 1){
                this.form.researchDevelopmentPlatformFile = null
            }
        },
        'form.scienceTechnologyProject'(val) {
            if(val == 1){
                this.form.scienceTechnologyProjectFile = null
            }
        },
        'form.innovationEntrepreneurshipCompetition'(val) {
            if(val == 0){
                this.form.innovationEntrepreneurshipCompetitionFile = null
            }
        },
        'form.riskVentureFunds'(val) {
            if(val == 0){
                this.form.riskVentureFundsFile = null
            }
        },
    },
    mounted() {
            this.form = this.formData
            if(this.formData.reasonForAudit){
                this.reason =  JSON.parse(this.formData.reasonForAudit)
            }
    },
    methods:{
        currentReset(n,b) {

            var valiSome = []
            if(n==1){
                valiSome = [
                'researchDevelopmentAmount',
                'researchDevelopmentAmountFile',
                'operatingIncomePreviousYear',
                // 'operatingIncomePreviousYearFile1',
                // 'operatingIncomePreviousYearFile2',
                // 'operatingIncomePreviousYearFile3',
                'operatingIncomePreviousYearFile',
                'researchDevelopmentPersonnel',
                'researchDevelopmentPersonnelFile',
                'totalNumberEmployees',
                'inventionPatentNumber',
                'pctPatentLicensing',
                'newSoftwareLicenseNumber',
                'technicalContractTurnover',
                'highTechEnterpriseCause',
                'incomeFromhighTechProducts',
                'netProfitAmount',
                'netProfitAmountFile',
                'yearBeforeNetProfitAmount',
                'yearBeforeNetProfitAmountFile',
                'netAssetAmount',
                'yearBeforeNetAssetAmount',
                'netAssetAmountFile',
                'yearBeforeNetAssetAmountFile',
                'inventionPatentNumberFile',
                'pctPatentLicensingFile',
                'technicalContractTurnoverFile',
                'newSoftwareLicenseNumberFile',
                'scienceTechnologySmesCause'
            ]
            }else{
                valiSome = [
                'freshCollegeGraduatesNumber',
                'researchDevelopmentPlatformFile',
                'scienceTechnologyProjectFile',
                'innovationEntrepreneurshipCompetitionFile',
                'riskVentureFunds',
                'riskVentureFundsFile'
            ]
            }
                this.$refs.ruleForm.validate(valiSome).then(() => {

                    if(b){
                        this.onSubmit(1)
                    }
                    setTimeout(() => {
                        this.current = n
                    }, 1000);
                }).catch(() => {
                    this.current = n-1
                    this.$notification.error({
                        message: '请检查必填项，必填项目不能不填。',
                        style: {
                            fontWeight: '600',
                        },
                    })
                });
        },
        smesChange(n){
            this.$refs.ruleForm.resetFields(n)
            if(this.form.scienceTechnologySmes=='1'){
                this.form.scienceTechnologySmesCause = ' '
            }
            if(this.form.highTechEnterprise=='1'){
                this.form.highTechEnterpriseCause = 'GR200000000000'
            }
        },
        getDetail(n) {
            this.postAction({
                url: enterpriseOperatingIncome.seedUpdate,
                params: {
                    ...this.formData,
                    ...this.form,
                    saveStatus:n,
                },
                returnMsg: true,
            }).then((res) => {
                if(res){
                    this.$router.push({
                        path: '/sys/manage'
                    });
                }

            }).catch((error) => {
                console.log('error',error)
            });
        },
        onSubmit(n){
            // this.form.operatingIncomePreviousYearFile = this.form.operatingIncomePreviousYearFile1+','+this.form.operatingIncomePreviousYearFile2+','+this.form.operatingIncomePreviousYearFile3
            this.$refs.ruleForm.validate().then(() => {
                this.getDetail(n)
            }).catch(()=>{
                this.$notification.error({
                                message: '请检查必填项，必填项目不能不填。',
                                style: {
                                    fontWeight: '600',
                                },
                            });
            });

        }
    }
}


</script>

<style lang="less" scoped>
:deep(.ant-input-group-wrapper){
    width:400px;margin-right:20px
}
.requStyle::after{
    content:' *';
    font-size: 17px;
    color: red;
}
.btFILE{
    position: relative;
    .ant-form-item{
        position: absolute;top: -65px;left: 300px;row-gap: 0px;

    }
}
.upIMg{
    position: relative;
    margin-bottom: -100px;
    .ant-form-item{
        position: relative;top: -65px;left:280px;margin-bottom: 0;
        .ant-upload-list{
            float: right;
        }
    }
}
.file-upload{
    margin-top:0
}
.integralItem-title{
    position:relative;
    margin: 20px 0;
    .bott{
        position: absolute;
        left:20px;
    }
    p,em{
        color:red
    }
    p{
        font-size: 12px;
    }
}
.integralItem-cont{
    margin:20px;
    .ant-input,input{
        width:60%;
    }
    .item-form{
        p{
            color:red;
            margin-top: 5px;
        }
    }
}
</style>
